<template>
	<div class="content">
		<h3>入库单统计</h3>
		<div class="item">
			<el-form ref="form" inline  :model="form" label-width="80px">				
				<el-form-item label="开始时间">
					<el-date-picker
						v-model="form.starttime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
                <el-form-item label="结束时间">
					<el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
                <el-form-item label="入库单号">
					<el-input v-model="form.odd"></el-input>
				</el-form-item>
                <el-form-item label="任务编号">
					<el-input v-model="form.rw"></el-input>
				</el-form-item>
				<el-form-item label="产品">
					<el-input v-model="form.product" placeholder="请选择产品" :value="form.productnum" @focus="productfocus"></el-input>
				</el-form-item>
                <el-form-item label="工厂">
					<el-select v-model="form.outstore" @focus="SelFactory" clearable placeholder="请选择">
						<el-option
						v-for="item in factorytable"
						:key="item.FactoryCode"
						:label="item.FactoryName"
						:value="item.FactoryCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="车间">
					<el-select v-model="form.cj" @focus="SelWorkShop" clearable placeholder="请选择">
						<el-option
						v-for="item in workShoptable"
						:key="item.workshopcode"
						:label="item.workshopname"
						:value="item.workshopcode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="生产线">
					<el-select v-model="form.scx" @focus="SelProductLine" clearable placeholder="请选择">
						<el-option
						v-for="item in productlinetable"
						:key="item.lineId"
						:label="item.lineName"
						:value="item.lineId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="班组">
					<el-select v-model="form.bz" @focus="SelShiftInfo" clearable placeholder="请选择">
						<el-option
						v-for="item in shiftInfotable"
						:key="item.shiftId"
						:label="item.shiftName"
						:value="item.shiftId">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary"  @click="SelInListQryStatistics">查 询</el-button>
				<el-button type="warning">重 置</el-button>
                <el-button type="success">数据下载</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table :data="tableData" border show-summary>
				<el-table-column align="center" prop="Order" label="出库单号"></el-table-column>
				<el-table-column align="center" prop="OutTime" label="更新时间"></el-table-column>
				<el-table-column align="center" prop="ProductCodeName" label="产品名称"></el-table-column>
                <el-table-column align="center" prop="ProductCode" label="产品编号"></el-table-column>
                <el-table-column align="center" prop="SpecName" label="规格名称"></el-table-column>
				<el-table-column align="center" prop="CardNums" label="托数量"></el-table-column>
                <el-table-column align="center" prop="CaseNums" label="箱数量"></el-table-column>
                <el-table-column align="center" prop="BoxNums" label="盒数量"></el-table-column>
                <el-table-column align="center" prop="TotalNums" label="合计"></el-table-column>
                <el-table-column align="center" prop="ShipperName" label="发货单位"></el-table-column>
				<el-table-column align="center" label="查看异常" >
					<template slot-scope="scope">
						<el-button type="text" @click="EditFactory(scope)">查看</el-button>
					</template>
				</el-table-column>
                <el-table-column align="center" prop="Remark" label="收货单位"></el-table-column>
                <el-table-column align="center" prop="Hnum_cs" label="状态"></el-table-column>
                <el-table-column align="center" prop="Hnum_pc" label="备注"></el-table-column>
                <el-table-column align="center" prop="Pnum_sb" label="操作员"></el-table-column>
				<el-table-column align="center" prop="Hnum_cs" label="创建时间"></el-table-column>
			</el-table>
			</el-table>
            <el-pagination background
			@current-change="handleCurrentPageChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
		<el-dialog
			title="选择产品"
			:visible.sync="dialogVisible"
			width="600px">
			<el-table :data="gridData" highlight-current-row
    @row-click="handleCurrentChange">
				<el-table-column align="center" width="80" property="DataId" label="序号"></el-table-column>
				<el-table-column align="center" width="80" property="Productcode" label="产品编号"></el-table-column>
				<el-table-column align="center" width="200" property="Productname" label="产品名称"></el-table-column>
				<el-table-column align="center" width="80" property="Shortname" label="产品品柜"></el-table-column>
				<el-table-column align="center" width="80" property="Norms" label="包装比例"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			tableData: [],
			form: {
				starttime:'',  //起始时间
				endtime: '',   //结束时间
				odd: '',       //入库单号
				rw: '',       //任务编号
				product: '',   //产品
				productnum:'', //产品编号
				outstore:'',   //工厂
				cj:'',   //车间
				scx:'',        //生产线
				bz: '',  //班组
			},
			gridData:[],
			factorytable:[],
			workShoptable:[],
			productlinetable:[],
			shiftInfotable:[],
			
			dialogVisible:false,
			
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
        		factoryCode:[
          			{ required: true, validator: validateNumber, message: '请输入工厂编码号,数字类型', trigger: 'blur' }
        		],
        		linkTel:[
          			{ required: true,  message: '请输入联系人电话', trigger: 'blur' }
				],
				linkMan:[
					{ required: true,  message: '请输入联系人姓名', trigger: 'blur' },
				],
				address:[
          			{ required: true,  message: '请输入工厂地址', trigger: 'blur' }
				],
			},
			pageIndex:1,
			pageNum:0,
		}
	},
	methods: {
		handleCurrentChange(data){
			this.current = data
		},
		confirm(){
			this.form.product = this.current.Shortname + this.current.Productname +this.current.Norms;
			this.form.num = this.current.Productcode;
			this.dialogVisible = false
		},
		productfocus(){
			//	请求产品数据
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params:{
					action:"query",
					cid:user.QyNum
				}
			})
			.then(res=>{
				console.log(res);
				this.gridData=res.DataList;
			})
			this.dialogVisible = true
		},
		
		SelFactory(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询工厂
			this.$axios({
        		method: 'post',
        		url:'/FW/Factory.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.factorytable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		SelWorkShop(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			if(this.form.outstore==null || this.form.outstore.length==0){
				this.$message({
            			showClose: true,
            			message:"请先选择工厂",
            			type: 'warning'
					});
					return;
			}
			//查询车间
			this.$axios({
        		method: 'post',
        		url:'/FW/WorkShop.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					factoryID:this.form.outstore
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.workShoptable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		SelProductLine(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			if(this.form.cj==null || this.form.cj.length==0){
				this.$message({
            			showClose: true,
            			message:"请先选择车间",
            			type: 'warning'
					});
					return;
			}
			//查询生产线
			this.$axios({
        		method: 'post',
        		url:'/FW/ProductLine.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					factoryID:this.form.outstore,
					WorkshopId:this.form.cj
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.productlinetable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		SelShiftInfo(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			if(this.form.scx==null || this.form.scx.length==0){
				this.$message({
            			showClose: true,
            			message:"请先选择生产线",
            			type: 'warning'
					});
					return;
			}
			//查询班组
			this.$axios({
        		method: 'post',
        		url:'/FW/ShiftInfo.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					FactoryID:this.form.outstore,
					WorkshopID:this.form.cj,
					LineID:this.form.scx
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.shiftInfotable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		handleCurrentPageChange(index){
			this.pageIndex=index;
			this.SelInListQryStatistics()
		},

		SelInListQryStatistics(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询入库单
			this.$axios({
        		method: 'post',
        		url:'/FW/OutListSTA.ashx',
        		params: {
					action:"InListSTA",
          			qry: this.form,
					cid:user.QyNum,
					pageIndex:this.pageIndex
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.tableData=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 80px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/inListQryStatistics.vue